import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { ModalContent, ModalOptions } from '@ap/modal';
import { ApContentModule } from '@ap/content';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApPanelComponent } from '@ap/panel';

@Component({
    selector: 'tip-summary',
    templateUrl: './tip-summary.component.html',
    styleUrls: ['../global.scss'],
    standalone: true,
    imports: [ApContentModule, ApAnalyticsModule, ApPanelComponent, NgTemplateOutlet]
})
export class TipSummaryComponent extends ModalContent<ModalOptions<any>> {}
